import React             from 'react';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                         BandeauSmartphone                     ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export class BandeauSmartphone extends React.Component {

        /* ---------------------- */
        /* Affichage du composant */
        /* ---------------------- */

        render () {

            /* ------------------------------ */
            /* Définition des CSS d'affichage */
            /* ------------------------------ */
        
            const styleBandeauSmartphone = {
                width           : (window.innerWidth -20) +  "px",
                backgroundColor : "#723937",
                display         : "block",
                marginLeft      : "auto",
                marginRight     : "auto",
                marginBottom    : "10px"
            };

            /* ------------------- */
            /* Renvoi du composant */
            /* ------------------- */

            return (

                <div style={styleBandeauSmartphone} >

                  <div className="medaillon"></div>
                  <div className="titre"></div>

                </div>

            )

        }
  
} // Fin de la classe BandeauSmartphone


// WEBPACK FOOTER //
// ./src/components/commun/BandeauSmartphone.js